import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { RecurrenceDay } from './recurrence-schedule';

@Metamodel.model({
    name: 'RecurrenceScheduleOcccurence',
    display: [shellStringResources.ModelName_RecurrenceScheduleOccurence]
})
export class RecurrenceScheduleOcccurence {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Day,
        constraint: {
            required: true
        }
    })
    public day: RecurrenceDay;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Occurence,
        constraint: {
            required: true,
            whole: true,
            minimum: -1,
            maximum: 5
        }
    })
    public occurrence: number;

    constructor(day: RecurrenceDay, occurrence: number) {
        this.day = day;
        this.occurrence = occurrence;
    }
}
